import React from 'react';

import { styled, Typography, useTheme } from '@mui/material';

import { useTranslation } from 'react-i18next';
import { SingleUserRolesAccessSection } from './components/RolesAccessSection';
import PersonalInformationSection from './components/PersonalInformationSection';
import WarningBanner from '../ui/WarningBanner';

const StySectionWrapper = styled('div')(({ theme }) => ({
    margin: `${theme.spacing(5)} 0`,
}));

const UserFormGeneralSection = ({
    warningMessage,
}: {
    warningMessage?: string;
}): JSX.Element => {
    const { t } = useTranslation();
    const theme = useTheme();
    return (
        <StySectionWrapper>
            <PersonalInformationSection />
            {!!warningMessage && <WarningBanner message={warningMessage} />}
            <Typography
                sx={{ marginBottom: theme.spacing(3) }}
                variant="body1Bold"
            >
                {t(
                    'adminSpace.createUser.modalStepper.generalSection.accessSectionTitle',
                )}
            </Typography>
            <SingleUserRolesAccessSection />
        </StySectionWrapper>
    );
};

export default UserFormGeneralSection;
